module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u_live-feed-646f425ae8729325eccb837db34d4466.svg";